var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_vm._v("\n    会员中心\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }